import React, { Component } from "react";
import { ModalComponent } from "../modal";
import { ModalTemplate } from "../modalTemplate";

import { Form, Image } from "react-bootstrap";
import IconPin from "../../../assets/icon-pin.png";
import { UploadAttachmentsWithTitleComponent } from "../uploadAttchements";
import { ERROR_MSG, DOCUMENT_FORMATS } from "../../../constant";
import { DisplayAttachments } from "../displayAttachments";
export class CommentComponent extends Component {
  state = {
    template: [],
    files: [],
    error: {}
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  validateField = async (fieldName, value) => {
    let _error = {
      comment: {
        error: value === null || !value.trim(),
        message: (value === null || !value.trim()) && ERROR_MSG.DEFAULT_MSG
      }
    };

    this.setState(
      {
        error: { ..._error }
      },
      () => {
        return true;
      }
    );
  };

  validateForm = async (fieldName, value) => {
    let _error = {
      comment: {
        error: value === null || !value.trim(),
        message: (value === null || !value.trim()) && ERROR_MSG.DEFAULT_MSG
      }
    };

    this.setState(
      {
        error: { ..._error }
      },
      () => {
        let { error, files } = this.state;
        let { onSubmit = () => {} } = this.props;
        if (error && error.comment && error.comment.error) {
          return false;
        } else {
          onSubmit(files);
          this.setState({ files: [] });
        }
      }
    );
  };

  render() {
    const { files, toggleAttachementDisplay, error } = this.state;
    const {
      show = false,
      onClose = () => {},
      onChange = () => {},
      title = "Add Comment",
      onSubmitTitle = "Add",
      isLoading = false,
      value = ""
    } = this.props;

    return (
      <div>
        {show ? (
          <ModalComponent
            centered={true}
            onClose={() => {
              this.setState({ error: {} }, () => {
                onClose();
              });
            }}
            containerClass="nodal-officer-popup comment-modal-body"
            isLoading={isLoading}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    {toggleAttachementDisplay ? (
                      <UploadAttachmentsWithTitleComponent
                        displayModal={toggleAttachementDisplay}
                        onCloseModal={this.onToggleAttachment}
                        fileFormats={DOCUMENT_FORMATS}
                        onSubmit={this.onSuccessUploadOfAttachmets}
                      />
                    ) : null}
                    <h4>{title}</h4>
                    <Form.Control
                      as="textarea"
                      value={value}
                      size="lg"
                      onBlur={() => this.validateField("comment", value)}
                      placeholder={`Type your Comment here…`}
                      onChange={e => onChange(e.target.value)}
                    />
                    {error.comment && error.comment.error ? (
                      <div className="error">{error.comment.message}</div>
                    ) : null}
                  </>
                }
                onSubmit={() => {
                  this.validateForm("comment", value);
                }}
                onClose={() => {
                  this.setState({ error: {} }, () => {
                    onClose();
                  });
                }}
                footerTemplate={
                  <div>
                    <Form.Group className="field-attachment">
                      <DisplayAttachments
                        filesArr={files}
                        onRemoveFile={this.onRemoveFile}
                        addAttchementRequired={false}
                        classes="attachments"
                      />
                    </Form.Group>
                    <div
                      className="add-attachment"
                      onClick={this.onToggleAttachment}
                    >
                      <div className="add-attachment-button">
                        <Image src={IconPin} alt="Attachment Icon" />
                        Add Attachment
                      </div>
                    </div>
                  </div>
                }
                onSubmitTitle={onSubmitTitle}
              />
            }
          />
        ) : null}
      </div>
    );
  }
}
